import {
  Box,
  Typography,
  useTheme,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import { tokens } from "../../theme";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import Header from "../../components/Header";
import DiscourseBrandingDetails from "../discourse/DiscourseBrandingDetails";

const DiscourseTokenGatingForm = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();
  const [discourseDetails, setDiscourseDetails] = useState({
    forumLink: location.state.forumLink,
    discourseAPI: location.state.discourseAPI,
    adminForumUserName: location.state.adminForumUserName,
    discourseConnectSecret: location.state.discourseConnectSecret,
    customerKeyForOTPVerification:
      location.state.otpVerificationKey.customerKeyForOTPVerification,
    customerAPIKeyForOTPVerification:
      location.state.otpVerificationKey.customerAPIKeyForOTPVerification,
  });

  const [discourseNftTokenGatingData, setDiscourseNftTokenGatingData] =
    useState(location.state.discourseNftTokenGatingData);

  const [nftCustomizationDetails, setNftCustomizationDetails] = useState(
    location.state.nftCustomizationDetails
  );

  const onHandleDiscourseDetailsInputChange = (event) => {
    const { name, value } = event.target;
    setDiscourseDetails({
      ...discourseDetails,
      [name]: value,
    });
  };

  const onHandleDiscourseNftTokenGatingDataInputChange = (event, index) => {
    const { name, value } = event.target;
    const listOfConfiguration = [...discourseNftTokenGatingData];
    listOfConfiguration[index][name] = value;
    setDiscourseNftTokenGatingData(listOfConfiguration);
  };
  //removes page path field if remove button clicked dynamically
  const handleRemoveClick = (index) => {
    const listOfConfiguration = [...discourseNftTokenGatingData];
    listOfConfiguration.splice(index, 1);
    setDiscourseNftTokenGatingData(listOfConfiguration);
  };
  //adds more page path field if add button clicked dynamically
  const handleAddClick = () => {
    setDiscourseNftTokenGatingData([
      ...discourseNftTokenGatingData,
      {
        categoryId: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };

  const onHandleNftCustomizationInputChange = (event) => {
    const { name, value } = event.target;
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: value,
    });
  };

  const onHandleCustomLogo = async (event) => {
    const data = event.target.files[0];
    if (data.size > 5 * 1000000) {
      swal({
        title: "Size is greater than 5 MB.",
        icon: "error",
      });
    } else {
      const { name, value } = event.target;
      const formData = new FormData();
      formData.append("image", data);
      let response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/upload-logo`,
        data: formData,
        headers: {
          "content-type": "application/json",
        },
      });
      let imageId = response.data.response;
      let imagePath = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BASE_URL}` + "/uploads/" + imageId,
      });

      imagePath = imagePath.config.url;
      imagePath = imagePath.replace(/\\/g, "/");

      setNftCustomizationDetails({
        ...nftCustomizationDetails,
        [name]: imagePath,
      });
    }
  };

  const gotoPreviousPage = () => {
    navigate("/configured-apps");
  };

  const onNftTokenGatingDataSubmit = (event) => {
    event.preventDefault();
    let discourseTokenGatingData = {
      forumLink: discourseDetails.forumLink,
      discourseAPI: discourseDetails.discourseAPI,
      adminForumUserName: discourseDetails.adminForumUserName,
      discourseConnectSecret: discourseDetails.discourseConnectSecret,
      otpVerificationKey: {
        customerKeyForOTPVerification:
          discourseDetails.customerKeyForOTPVerification,
        customerAPIKeyForOTPVerification:
          discourseDetails.customerAPIKeyForOTPVerification,
      },
      discourseNftTokenGatingData,
      forumLinkBeforeUpdation: location.state.forumLink,
    };
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/discourse-nft-token-gating-data-edit`,
        {
          discourseTokenGatingData,
          nftCustomizationDetails,
        },
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
            customer_id: location.state._id,
          },
        }
      )
      .then((res) => {
        swal({
          text: res.data.title,
          icon: "success",
          // type: "success",
        });
        navigate("/configured-apps");
      })
      .catch((err) => {
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
          //  type: "error",
        });
      });
  };

  return (
    <Box
      m="20px"
      ml="90px"
      sx={{ boxShadow: "15" }}
      mr="90px"
      paddingLeft="75px"
      paddingTop="10px"
    >
      <Header
        title="Discourse Token Gating Details"
        subtitle="Fill the required field"
      />
      <Box
        sx={{
          mt: 1,
          width: 900,
          "& Grid": {
            color: colors.greenAccent[300],
          },
        }}
      >
        <form onSubmit={onNftTokenGatingDataSubmit}>
          <Grid container rowSpacing={2} columnSpacing={2} sx={{ mt: 3 }}>
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="forumLink"
                label="Enter the discourse forum link "
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2 }}
                value={discourseDetails.forumLink}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="discourseConnectSecret"
                label="Enter the Discourse Connect Secret "
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2 }}
                value={discourseDetails.discourseConnectSecret}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="customerKeyForOTPVerification"
                label="Enter the customer key for OTP Verification"
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2 }}
                value={discourseDetails.customerKeyForOTPVerification}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="customerAPIKeyForOTPVerification"
                label="Enter the customer API Key for OTP Verification"
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2 }}
                value={discourseDetails.customerAPIKeyForOTPVerification}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
            {discourseDetails.discourseAPI && (
              <Grid item xs={6} md={6}>
                <TextField
                  name="discourseAPI"
                  label="Enter the discourse forum API "
                  variant="outlined"
                  type="text"
                  fullWidth
                  sx={{ mt: 1, boxShadow: 2 }}
                  value={discourseDetails.discourseAPI}
                  onChange={onHandleDiscourseDetailsInputChange}
                  required
                />
              </Grid>
            )}
            {discourseDetails.discourseAPI && (
              <Grid item xs={6} md={6}>
                <TextField
                  name="adminForumUserName"
                  label="Enter the username of the admin account "
                  variant="outlined"
                  type="text"
                  fullWidth
                  sx={{ mt: 1, boxShadow: 2 }}
                  value={discourseDetails.adminForumUserName}
                  onChange={onHandleDiscourseDetailsInputChange}
                  required
                />
              </Grid>
            )}
            {discourseDetails.discourseAPI && (
              <Grid item xs={6} md={6}>
                <Typography
                  component="h6"
                  variant="h5"
                  color={colors.greenAccent[400]}
                  fontFamily="Helvetica Neue"
                  sx={{ mb: 1 }}
                >
                  Token Gating Info
                </Typography>
              </Grid>
            )}
            {discourseDetails.discourseAPI &&
              discourseNftTokenGatingData.map((currentElement, index) => {
                return (
                  <Grid container key={index} direction="row">
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 6, mt: 2, boxShadow: 2 }}
                        fullWidth
                        required
                        name="categoryId"
                        variant="outlined"
                        label="Enter the category Id"
                        type="text"
                        id="categoryId"
                        value={currentElement.categoryId}
                        onChange={(event) =>
                          onHandleDiscourseNftTokenGatingDataInputChange(
                            event,
                            index
                          )
                        }
                      />
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <FormControl
                        sx={{ ml: 6.5, mt: 2, boxShadow: 2 }}
                        fullWidth
                        required
                      >
                        <InputLabel id="demo-simple-select-label">
                          Select BlockChain
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="blockChain"
                          label="Select BlockChain"
                          value={currentElement.blockChain}
                          onChange={(event) =>
                            onHandleDiscourseNftTokenGatingDataInputChange(
                              event,
                              index
                            )
                          }
                        >
                          <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                          <MenuItem value={"Polygon"}>Polygon</MenuItem>
                          <MenuItem value={"POAP/xDai"}>POAP/xDAI</MenuItem>
                          <MenuItem value={"Sepolia-Ethereum"}>
                            Sepolia Ethereum
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <FormControl
                        sx={{ ml: 7, mt: 2, boxShadow: 2 }}
                        fullWidth
                        required
                      >
                        <InputLabel id="demo-simple-select-label">
                          Token Standard
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="tokenStandard"
                          label="Enter Smart Contract Token Standard"
                          value={
                            currentElement.blockChain == "POAP/xDai"
                              ? (currentElement.tokenStandard = "ERC721")
                              : currentElement.tokenStandard
                          }
                          onChange={(event) =>
                            onHandleDiscourseNftTokenGatingDataInputChange(
                              event,
                              index
                            )
                          }
                          disabled={
                            currentElement.blockChain == "POAP/xDai"
                              ? true
                              : false
                          }
                        >
                          <MenuItem value={"ERC721"}>ERC721</MenuItem>
                          <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={1} xs={1} sm={1}>
                      {
                        <Button
                          disabled={
                            discourseNftTokenGatingData.length - 1 === index
                              ? false
                              : true
                          }
                          variant="contained"
                          sx={{ mt: 6, ml: 8, backgroundColor: "#6870fa" }}
                          onClick={handleAddClick}
                          color="info"
                        >
                          Add
                        </Button>
                      }
                    </Grid>
                    <Grid item md={1} xs={1} sm={1}>
                      {
                        <Button
                          disabled={
                            discourseNftTokenGatingData.length == 1
                              ? true
                              : false
                          }
                          variant="contained"
                          sx={{ mt: 6, ml: 8 }}
                          onClick={() => handleRemoveClick(index)}
                          color="error"
                        >
                          Remove
                        </Button>
                      }
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 6, boxShadow: 2 }}
                        fullWidth
                        required
                        name="contractAddress"
                        label={
                          currentElement.blockChain == "POAP/xDai"
                            ? "Event ID"
                            : "Contract Address"
                        }
                        variant="outlined"
                        type="text"
                        id="contractAddress"
                        value={currentElement.contractAddress}
                        onChange={(event) =>
                          onHandleDiscourseNftTokenGatingDataInputChange(
                            event,
                            index
                          )
                        }
                      />
                    </Grid>

                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 6.5, boxShadow: 2 }}
                        fullWidth
                        name="tokenId"
                        variant="outlined"
                        value={currentElement.tokenId}
                        label="Token Id"
                        type="text"
                        id="tokenId"
                        onChange={(event) =>
                          onHandleDiscourseNftTokenGatingDataInputChange(
                            event,
                            index
                          )
                        }
                      />
                    </Grid>
                    <Grid item md={3} sm={3} xs={3}>
                      <TextField
                        sx={{ ml: 6.9, boxShadow: 2 }}
                        fullWidth
                        required
                        name="nftsRequired"
                        variant="outlined"
                        label="Nfts Required"
                        inputProps={{ type: "number", min: 1 }}
                        id="nftsRequired"
                        value={currentElement.nftsRequired}
                        onChange={(event) => {
                          const value = event.target.value;
                          if (value === "" || value > 0) {
                            onHandleDiscourseNftTokenGatingDataInputChange(
                              event,
                              index
                            );
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            <Box style={{ marginLeft: "16px", marginTop: "20px" }}>
              <DiscourseBrandingDetails
                onHandleNftCustomizationInputChange={
                  onHandleNftCustomizationInputChange
                }
                nftCustomizationDetails={nftCustomizationDetails}
                onHandleCustomLogo={onHandleCustomLogo}
              />
            </Box>
            <Grid item md={10}>
              <Button
                className="custom-color-button"
                type="submit"
                size="small"
                variant="contained"
                color="info"
                sx={{ mt: 4, mb: 3 }}
              >
                Update
              </Button>
            </Grid>
            <Grid item md={2}>
              <Button
                className="custom-color-button"
                size="small"
                variant="contained"
                color="info"
                sx={{ mt: 4, mb: 3 }}
                onClick={gotoPreviousPage}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default DiscourseTokenGatingForm;
